import React from 'react';
import PropTypes from "prop-types";

import arrowImage from '../../../assets/arrow.png';
import './ArrowLink.scss';

const ArrowLink = ({ aText, href, title, alt, onClick, target = "_self" }) => {

    console.log(href)
    let aTitleValue = title ? title : aText;
    return (
        <a onClick={onClick} href={href} target={target} title={aTitleValue} className="arrow-link-molecule">{aText}
    </a>
    )
}
export default ArrowLink

ArrowLink.propTypes = {
    aText: PropTypes.string,
    href: PropTypes.string,
    title: PropTypes.string,
    alt: PropTypes.string,
};

ArrowLink.defaultProps = {
    aText: null,
    href: "javascript:void(0)",
    title: null,
    alt: null,
};
